function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5ab6e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#152f3d"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-img-01-comp-background-triangles"
}, /*#__PURE__*/React.createElement("rect", {
  width: 690,
  height: 1040
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "img-01-comp-background-triangles",
  clipPath: "url(#clip-img-01-comp-background-triangles)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_386",
  "data-name": "Grupo 386",
  transform: "translate(-1293 -40)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_344",
  "data-name": "Grupo 344"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_342",
  "data-name": "Grupo 342",
  transform: "translate(0 -54)",
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_4",
  "data-name": "Pol\\xEDgono 4",
  d: "M87,0l87,150H0Z",
  transform: "translate(1906.804 184.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_14",
  "data-name": "Pol\\xEDgono 14",
  d: "M87,0l87,150H0Z",
  transform: "translate(1906.804 548.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_8",
  "data-name": "Pol\\xEDgono 8",
  d: "M87,0l87,150H0Z",
  transform: "translate(1906.804 367.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_7",
  "data-name": "Pol\\xEDgono 7",
  d: "M87,0l87,150H0Z",
  transform: "translate(1752.804 275.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_15",
  "data-name": "Pol\\xEDgono 15",
  d: "M87,0l87,150H0Z",
  transform: "translate(1752.804 824.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_12",
  "data-name": "Pol\\xEDgono 12",
  d: "M87,0l87,150H0Z",
  transform: "translate(1752.804 639.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_20",
  "data-name": "Pol\\xEDgono 20",
  d: "M87,0l87,150H0Z",
  transform: "translate(1906.804 917.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_18",
  "data-name": "Pol\\xEDgono 18",
  d: "M87,0l87,150H0Z",
  transform: "translate(1597.804 731.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_21",
  "data-name": "Pol\\xEDgono 21",
  d: "M87,0l87,150H0Z",
  transform: "translate(1597.804 917.804) rotate(90)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_3",
  "data-name": "Pol\\xEDgono 3",
  d: "M87,0l87,150H0Z",
  transform: "translate(1982.648 224.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_6",
  "data-name": "Pol\\xEDgono 6",
  d: "M87,0l87,150H0Z",
  transform: "translate(1828.648 315.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_10",
  "data-name": "Pol\\xEDgono 10",
  d: "M87,0l87,150H0Z",
  transform: "translate(1828.648 497.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_16",
  "data-name": "Pol\\xEDgono 16",
  d: "M87,0l87,150H0Z",
  transform: "translate(1828.648 862.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_13",
  "data-name": "Pol\\xEDgono 13",
  d: "M87,0l87,150H0Z",
  transform: "translate(1673.648 769.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_17",
  "data-name": "Pol\\xEDgono 17",
  d: "M87,0l87,150H0Z",
  transform: "translate(1673.648 954.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_22",
  "data-name": "Pol\\xEDgono 22",
  d: "M87,0l87,150H0Z",
  transform: "translate(1518.648 1047.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_9",
  "data-name": "Pol\\xEDgono 9",
  d: "M87,0l87,150H0Z",
  transform: "translate(1828.648 678.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_19",
  "data-name": "Pol\\xEDgono 19",
  d: "M87,0l87,150H0Z",
  transform: "translate(1828.648 1047.256) rotate(150)",
  opacity: 0.71,
  fill: "url(#linear-gradient)"
})))));

function SvgBackgroundTriangles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 690,
    height: 1040,
    viewBox: "0 0 690 1040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTriangles);
export default __webpack_public_path__ + "static/media/background-triangles.f8699993.svg";
export { ForwardRef as ReactComponent };